import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Product item type
export interface ProductItems {
  id: string;
  [key: string]: any;
}

// API response shape
interface PromoListResponse {
  productItems: ProductItems[];
  total: number;
  page: number;
  totalPages: number;
}

// Slice state
interface PromoState {
  data: PromoListResponse | null;
  loading: boolean;
  error: string | null;
}

// Update payload
export interface PromoUpdatePayload {
  id: string;
  [key: string]: any;
}

const initialState: PromoState = {
  data: null,
  loading: false,
  error: null,
};

const promoSlice = createSlice({
  name: "promo",
  initialState,
  reducers: {
    setPromoList(state, action: PayloadAction<PromoListResponse>) {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },

    addPromo(state, action: PayloadAction<ProductItems>) {
      const newPromo = action.payload;

      if (state.data) {
        state?.data?.productItems?.unshift(newPromo);
        state.data.total += 1;

        // keep pagination consistent
        if (state.data.productItems.length > 10) {
          state?.data?.productItems?.pop();
        }
      } else {
        state.data = {
          productItems: [newPromo],
          total: 1,
          page: 1,
          totalPages: 1,
        };
      }
    },

    promoUpdate(state, action: PayloadAction<PromoUpdatePayload>) {
      const { id, ...updates } = action.payload;
      if (!state.data?.productItems) return;

      const promo = state.data.productItems.find((p) => p.id === id);
      if (promo) {
        Object.assign(promo, updates);
      }
    },

    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
  },
});

export const {
  setPromoList,
  addPromo,
  promoUpdate,
  setLoading,
  setError,
} = promoSlice.actions;

export default promoSlice.reducer;
